<template>
    <component :is="getComp(tempactive)" :temdata="temdata" :isFirst="isFirst"></component>
</template>

<script>
import {proshare} from '@/api/new'
const requireTemp = require.context('../../components/temp', false, /\.vue$/)
export default {
    data() {
        return {
            templist: [],
            tempactive: 'template2',
            temdata: {},
            isFirst: false,
        }
    },
    mounted() {
        var projectId = this.$route.query.projectId
        this.getTemid(projectId)
    },
    methods: {
        loadTemp() {
            const componentemp = requireTemp.keys().map(key => requireTemp(key))
            const loadhead = componentemp.map(component => component.default)
            this.templist = loadhead
        },
        getComp(name) {
            let comp = this.templist.find(item => item.name == name)
            return comp
        },
        getTemid(id) {
            const params = {
                ids: id
            }
            proshare(params).then(res => {
                if (res.status == 200) {
                    this.tempactive = res.data.template_local_id
                    this.temdata = res.data
                    this.isFirst = this.temdata.isFirst
                    this.loadTemp()
                } else {
                    this.$message.warning(res.msg || '该项目已删除')
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

</style>